import React from 'react'
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'
import momentTimezone from 'moment-timezone'
import 'moment/locale/pt-br'

class DateField extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      value: props.input.value
    }
    this.inputRef = React.createRef()
  }
  componentDidMount () {
    if (this.props.value) {
      this.setState({ value: this.props.value })
    }
  }
  render () {
    const {
      id,
      input: {
        value: inputValue,
        onChange,
        ...restInput
      },
      placeholder,
      meta: { touched, error },
      disabled
    } = this.props

    const {
      value
    } = this.state
    return (
      <MuiPickersUtilsProvider utils={MomentUtils} locale='pt-br' moment={momentTimezone}>
        <DatePicker
          format='DD/MM/YYYY'
          id={id}
          value={value || null}
          emptyLabel=''
          onChange={this.handleChange}
          cancelLabel='Cancelar'
          helperText={touched && error}
          error={touched && !!error}
          label={placeholder}
          placeholder={'DD/MM/AAAA'}
          margin='normal'
          disableFuture
          inputProps={{
            'data-testid': `test-${id}`,
            disabled: disabled
          }}
          {...restInput} />
      </MuiPickersUtilsProvider>
    )
  }
  handleChange = date => {
    const {
      input: {
        onChange
      }
    } = this.props
    this.setState({
      value: date
    }, () => {
      onChange(date)
    })
  }
}

export default DateField
